import React from 'react';

const SaiTrongLuongComponent = () => {
  return (
    <div>
      <h1>Sai trọng lượng</h1>
      <p>Danh sách các chuyến với thông tin trọng lượng không chính xác.</p>
    </div>
  );
};

export default SaiTrongLuongComponent;